import { useContext } from 'react';

import { ColSize, ContentSection, RowSize } from '../../../../../../../../../shared/components';
import {
  Form,
  SelectForm,
} from '../../../../../../../../../shared/components/Form';
import { QuotationStepButtons } from '../../../../../shared';

import { QuotationInfoContext } from '../../../../../shared/contexts';
import { StepTwoFormContext } from '../../contexts/StepTwoForm';
import { WizardDataFormContext } from '../../../../Wizard/contexts/WizardDataForm';

import { ActividadesComercio } from '../../../../../../../../../shared/interfaces';
import { QuotationStep } from '../../../../../shared/interfaces';

import { ValidateForm } from '../../../../../../../../../shared/utils';

import './index.css';

export const CategorySelection = () => {
  const validateForm = new ValidateForm();

  const { rubricList, rubricListOptions } = useContext(WizardDataFormContext);
  const { setCurrentStep } = useContext(QuotationInfoContext);
  const { stepTwoForm, setRubricSelected} = useContext(StepTwoFormContext);

  const onValidateForm = async () => {
    try {
      await stepTwoForm?.validateFields();

      const rubric = stepTwoForm?.getFieldValue('category') as string;
      const rubricSelected = rubricList?.actividadesComercio.find(
        (item: ActividadesComercio) =>
          `${item.capituloTarifa}${item.capituloTarifaInciso1}${item.capituloTarifaInciso2}` === rubric
      );

      if (rubricSelected) setRubricSelected(rubricSelected);

      setCurrentStep(QuotationStep.THREE);
    } catch {}
  };

  return (
    <>
      <ContentSection level='h3' title='Rubro'>
        <Form
          formProps={{
            form: stepTwoForm,
            name: 'category-selection-form',
          }}
        >
          <RowSize>
            <ColSize size={25}>
              <SelectForm
                formProps={{
                  label: 'Rubro',
                  name: 'category',
                  rules: validateForm.generateRules({
                    label: 'rubro',
                    rules: ['required'],
                  }),
                }}
                selectProps={{
                  loading: !rubricListOptions,
                  options: rubricListOptions,
                  showSearch: true,
                }}
              />
            </ColSize>
          </RowSize>
        </Form>
      </ContentSection>

      <QuotationStepButtons
        label='Continuar'
        onClick={onValidateForm}
        onPressBackButton={() => setCurrentStep(QuotationStep.ONE)}
      />
    </>
  );
};
